var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "card-module" },
    [
      _c("div", { staticClass: "module-header" }, [
        _c("div", { staticClass: "module-title" }, [
          _c("i", {
            staticClass: "iconfont icon-a-lujing642",
            staticStyle: { "font-size": "20px" },
          }),
          _vm._v(" " + _vm._s(_vm.$t("home.announcementCenter")) + " "),
        ]),
        _c(
          "div",
          { staticClass: "notice-tabs" },
          _vm._l(_vm.noticeTypeList, function (tab) {
            return _c(
              "div",
              {
                key: tab.type,
                class: [
                  "notice-tab",
                  _vm.activeTab === tab.type ? "active" : "",
                ],
                on: {
                  click: function ($event) {
                    return _vm.handleTabClick(tab.type)
                  },
                },
              },
              [
                _vm._v(" " + _vm._s(tab.typeName)),
                tab.count != null
                  ? _c("span", { staticClass: "notice-tab-count" }, [
                      _vm._v("(" + _vm._s(tab.count) + ")"),
                    ])
                  : _vm._e(),
              ]
            )
          }),
          0
        ),
      ]),
      _c(
        "div",
        { staticClass: "list-container" },
        _vm._l(_vm.list, function (item, index) {
          return _c(
            "div",
            { key: index, class: ["announce-item", _vm.typeClass(item.type)] },
            [
              item.isTop
                ? _c("div", { staticClass: "top-flag" }, [
                    _vm._v(_vm._s(_vm.$t("spareNumberPoo.pinToTop"))),
                  ])
                : _vm._e(),
              _c("div", { staticClass: "main-col" }, [
                _c("div", { staticClass: "tag-row" }, [
                  _c("div", { class: ["tag", _vm.tagClass(item.type)] }, [
                    _vm._v(" " + _vm._s(item.typeName) + " "),
                  ]),
                  _c("div", { staticClass: "date" }, [
                    _vm._v(_vm._s(item.createTime)),
                  ]),
                ]),
                _c("div", { staticClass: "item-title" }, [
                  item.textUrl
                    ? _c(
                        "div",
                        {
                          staticClass: "notice-card-image",
                          on: {
                            click: function ($event) {
                              return _vm.getImgSrc(item.textUrl)
                            },
                          },
                        },
                        [
                          _c("el-image", {
                            staticStyle: { width: "100%", height: "100%" },
                            attrs: { src: item.textUrl, fit: "cover" },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" " + _vm._s(item.title) + " "),
                  item.abstract
                    ? _c("div", { staticClass: "item-desc" }, [
                        _vm._v(_vm._s(item.abstract || "--")),
                      ])
                    : _vm._e(),
                  item.text
                    ? _c(
                        "div",
                        {
                          staticClass: "item-text",
                          domProps: { innerHTML: _vm._s(item.text) },
                        },
                        [_vm._v(_vm._s(item.text || "--"))]
                      )
                    : _vm._e(),
                ]),
              ]),
            ]
          )
        }),
        0
      ),
      _vm.showViewer
        ? _c("ElImageViewer", {
            attrs: { "on-close": _vm.closeViewer, "url-list": _vm.imgArr },
          })
        : _vm._e(),
      _c("systemMessagePopUp", {
        ref: "systemMessagePopUpRef",
        on: { readMessage: _vm.onReadMessage },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }